import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AddProducts = () => {

  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    total_quantity: "",
    price_per_unit: "",
    rent_per_day: ""
  });

  const [products, setProducts] = useState([]);

  // =========================================
  // HANDLE INPUT CHANGE
  // =========================================

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  // =========================================
  // FETCH PRODUCTS
  // =========================================

  const fetchProducts = () => {

    fetch("/api/products")
      .then(res => res.json())
      .then(data => {

        if (Array.isArray(data)) {

          setProducts(data);

        } else if (
          Array.isArray(data.products)
        ) {

          setProducts(data.products);

        } else {

          setProducts([]);
        }
      })
      .catch(err => {

        console.error(err);
        setProducts([]);
      });
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // =========================================
  // SUBMIT PRODUCT
  // =========================================

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      const res = await fetch(
        "/api/add-product",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(form)
        }
      );

      const data = await res.json();

      alert(data.message);

      setForm({
        name: "",
        total_quantity: "",
        price_per_unit: "",
        rent_per_day: ""
      });

      fetchProducts();

    } catch (error) {

      console.error(error);
      alert("Error adding product");
    }
  };

  // =========================================
  // RECENT PRODUCTS
  // =========================================

  const recentProducts =
    [...products]
      .reverse()
      .slice(0, 10);

  return (
<div className="min-h-screen bg-[#F5F7FB] p-4 md:p-6 space-y-6">

      {/* ========================================= */}
      {/* HERO */}
      {/* ========================================= */}

      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-3xl p-5 md:p-8 text-white shadow-xl">

       <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

          <div>

            <p className="uppercase tracking-widest text-indigo-200 text-sm">
              Inventory Management
            </p>

           <h1 className="text-2xl md:text-4xl font-bold mt-2">
              Add Products
            </h1>

            <p className="mt-3 text-indigo-100">
              Manage inventory, pricing and rental stock efficiently.
            </p>

          </div>

          <div className="hidden md:flex flex-col items-end">

            <div className="bg-white/10 backdrop-blur-md px-6 py-4 rounded-2xl border border-white/20">

              <p className="text-sm text-indigo-100">
                Total Products
              </p>

              <h2 className="text-4xl font-bold mt-1">
                {products.length}
              </h2>

            </div>

          </div>

        </div>

      </div>

      {/* ========================================= */}
      {/* MAIN GRID */}
      {/* ========================================= */}

     <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

        {/* ========================================= */}
        {/* ADD PRODUCT FORM */}
        {/* ========================================= */}

       <div className="col-span-1 lg:col-span-8 bg-white rounded-3xl p-5 md:p-8 shadow-sm border border-gray-100">

          <div className="flex justify-between items-center mb-8">

            <div>

              <h2 className="text-2xl font-bold text-gray-800">
                Product Details
              </h2>

              <p className="text-sm text-gray-500 mt-1">
                Enter inventory information carefully.
              </p>

            </div>

            <div className="bg-indigo-100 text-indigo-600 px-4 py-2 rounded-xl text-sm font-semibold">

              Inventory

            </div>

          </div>

          <form
            onSubmit={handleSubmit}
            className="space-y-6"
          >

            {/* PRODUCT NAME */}

            <div>

              <label className="block text-sm font-medium text-gray-600 mb-2">

                Product Name

              </label>

              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Enter product name"
                className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
              />

            </div>

            {/* GRID */}

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">

              {/* QUANTITY */}

              <div>

                <label className="block text-sm font-medium text-gray-600 mb-2">

                  Quantity

                </label>

                <input
                  type="number"
                  name="total_quantity"
                  value={form.total_quantity}
                  onChange={handleChange}
                  placeholder="0"
                  className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition"
                />

              </div>

              {/* PRICE */}

              <div>

                <label className="block text-sm font-medium text-gray-600 mb-2">

                  Price

                </label>

                <input
                  type="number"
                  name="price_per_unit"
                  value={form.price_per_unit}
                  onChange={handleChange}
                  placeholder="0"
                  className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition"
                />

              </div>

              {/* RENT */}

              <div>

                <label className="block text-sm font-medium text-gray-600 mb-2">

                  Rent / Day

                </label>

                <input
                  type="number"
                  name="rent_per_day"
                  value={form.rent_per_day}
                  onChange={handleChange}
                  placeholder="0"
                  className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
                />

              </div>

            </div>

            {/* BUTTONS */}

            <div className="flex flex-col sm:flex-row justify-end gap-4 pt-6 border-t">

              <button
                type="button"
                onClick={() =>
                  navigate("/dashboard")
                }
                className="w-full sm:w-auto px-6 py-3 rounded-2xl border border-gray-200 text-gray-600 hover:bg-gray-100 transition"
              >
                Cancel
              </button>

              <button
                type="submit"
               className="w-full sm:w-auto bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-3 rounded-2xl font-semibold hover:shadow-lg transition"
              >
                Add Product
              </button>

            </div>

          </form>

        </div>

        {/* ========================================= */}
        {/* SIDE PANEL */}
        {/* ========================================= */}

       <div className="col-span-1 lg:col-span-4 space-y-6">

          {/* STATS */}

          <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-100">

            <p className="text-sm text-gray-500">
              Inventory Count
            </p>

            <h2 className="text-5xl font-bold text-indigo-600 mt-4">

              {products.length}

            </h2>

            <div className="mt-6 h-2 bg-gray-100 rounded-full overflow-hidden">

              <div className="w-[75%] h-full bg-gradient-to-r from-indigo-500 to-cyan-500 rounded-full" />

            </div>

          </div>

          {/* QUICK ACTIONS */}

          <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-100">

            <h3 className="text-lg font-bold text-gray-800 mb-5">
              Quick Actions
            </h3>

            <div className="space-y-4">

              <button
                onClick={() =>
                  navigate("/products")
                }
                className="w-full bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-2xl py-4 px-5 text-left transition"
              >
                📦 View Products
              </button>

              <button
                onClick={() =>
                  navigate("/dashboard")
                }
                className="w-full bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-2xl py-4 px-5 text-left transition"
              >
                📊 Dashboard
              </button>

            </div>

          </div>

        </div>

      </div>

      {/* ========================================= */}
      {/* RECENT PRODUCTS */}
      {/* ========================================= */}

      <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-100">

        <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4 mb-6">

          <div>

            <h2 className="text-2xl font-bold text-gray-800">
              Recent Products
            </h2>

            <p className="text-sm text-gray-500 mt-1">
              Latest inventory items
            </p>

          </div>

          <button
            onClick={() =>
              navigate("/products")
            }
            className="text-indigo-600 font-medium hover:underline"
          >
            View More →
          </button>

        </div>

        <div className="overflow-x-auto">

         <table className="min-w-[700px] w-full">

            <thead>

              <tr className="text-left text-gray-500 border-b">

                <th className="pb-4">
                  Product
                </th>

                <th>
                  Total
                </th>

                <th>
                  Available
                </th>

                <th>
                  Price
                </th>

                <th>
                  Rent / Day
                </th>

              </tr>

            </thead>

            <tbody>

              {recentProducts.map((p) => (

                <tr
                  key={p.id}
                  className="border-b hover:bg-gray-50 transition"
                >

                  <td className="py-5 font-medium text-gray-700">

                    {p.name}

                  </td>

                  <td>

                    {p.total_quantity}

                  </td>

                  <td>

                    <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-semibold">

                      {p.available_quantity}

                    </span>

                  </td>

                  <td className="font-semibold text-gray-700">

                    ₹{p.price_per_unit}

                  </td>

                  <td className="font-semibold text-indigo-600">

                    ₹{p.rent_per_day}

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
};

export default AddProducts;